module.exports = __webpack_public_path__ + "img/205.2bb3f3f6.png";